var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTreatment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6666 11.6667H13.3333C12.4133 11.6667 11.6666 10.9201 11.6666 10.0001V6.66675L20 8.33341L28.3333 6.66675V10.0001C28.3333 10.9201 27.5866 11.6667 26.6666 11.6667Z",
    fill: "#015BBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6667 5.00008H24.6933C24.005 3.06175 22.1733 1.66675 20 1.66675C17.8267 1.66675 15.995 3.06175 15.3067 5.00008H8.33333C6.49167 5.00008 5 6.49175 5 8.33341V31.6667C5 33.5084 6.49167 35.0001 8.33333 35.0001H31.6667C33.5083 35.0001 35 33.5084 35 31.6667V8.33341C35 6.49175 33.5083 5.00008 31.6667 5.00008ZM8.33333 8.33341H20C19.08 8.33341 18.3333 7.58675 18.3333 6.66675C18.3333 5.74675 19.08 5.00008 20 5.00008C20.92 5.00008 21.6667 5.74675 21.6667 6.66675C21.6667 7.58675 20.92 8.33341 20 8.33341H31.6667V31.6667H8.33333V8.33341Z",
    fill: "#015BBB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.265 18.2683L25.735 25.065M20 15V28.3333V15ZM25.735 18.2683L14.265 25.065L25.735 18.2683Z",
    stroke: "#015BBB",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M23.3333 6.66675C23.3333 8.50841 21.8416 10.0001 20 10.0001C18.1583 10.0001 16.6666 8.50841 16.6666 6.66675H6.66663V33.3334H33.3333V6.66675H23.3333Z",
    fill: "#015BBB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreatment);
export default __webpack_public_path__ + "static/media/treatment.c9a13663dadae37206fa6367c7147856.svg";
export { ForwardRef as ReactComponent };